import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
import { Sysappbuttons } from 'fccore2';
/**
 * fc-tlbliståè¡¨å·¥å·æ 
 * 
 * åè¡¨å·¥å·æ ç»ä»¶ã
 * 
 * åè¡¨å·¥å·æ æé®ï¼å¦ä¿å­ãæ°å¢ãä¿®æ¹ãå é¤ç­æé®ã
 *
 */
@Component({
    selector: 'fc-tlblist',
    template: `
    <div class="fc-tlblist"   *ngIf="fcHasGap===undefined"  [ngClass]="{'fc-tlblist-small':fcSize === 'small','fc-tlblist-default':fcSize === 'default','fc-tlblist-large':fcSize === 'large','fc-left':fcLayout==='left','fc-center':fcLayout==='center','fc-right':fcLayout==='right'}">
        <fc-button [fcSize]="fcSize" fcMode="group"   [fcGroup]="fcButtons" [fcDisableds]="fcDisableds" (fcEvent)="event($event.eventName,$event.param)"></fc-button>
    </div>
    <div class="fc-tlblist"   *ngIf="fcHasGap!==undefined"  [ngClass]="{'fc-hasgap':fcHasGap==='Y','fc-tlblist-small':fcSize === 'small','fc-tlblist-default':fcSize === 'default','fc-tlblist-large':fcSize === 'large','fc-left':fcLayout==='left','fc-center':fcLayout==='center','fc-right':fcLayout==='right'}">
        <fc-button [fcSize]="fcSize" fcMode="group"  [fcGroup]="fcButtons"  [fcDisableds]="fcDisableds"  [fcDisableds]="fcDisableds" (fcEvent)="event($event.eventName,$event.param)"></fc-button>
    </div>
    `,
    styles: [`
        .fc-tlblist{
            margin-top:5px;
            margin-bottom:5px;
            text-align: right;
        }
        .fc-center{
            text-align: center;
        }
        .fc-right{
            text-align: right;  
        }
        :host ::ng-deep .fc-tlblist .ant-btn{
            // color:#333333;
        }
        :host ::ng-deep .fc-tlblist .ant-btn{
            // border-color:#7d7d7d;
         }
        :host ::ng-deep .fc-tlblist .button-group .ant-btn:hover,:host ::ng-deep .fc-tlblist .button-group .ant-btn:focus {
            color: #1890ff;
        }
        :host ::ng-deep .fc-hasgap .ant-btn-group > .ant-btn{
            margin-right:10px;
        }
    `]
})
export class FctlblistComponent extends FcinputComponent {
    // æ°æ®åå®¹ç¬¦åå¨æäºèå´çæ¶åæ¾ç¤ºæäºæä½æé®ï¼ä¸ç¬¦ååä¸æ¾ç¤ºï¼
    // å·ä½å®æ½æ¹æ¡ä¸ºå¨ç»ä»¶fclistdataç»ä»¶ä¸­å¢å æ°å±æ§ï¼
    // fcViewActionStrategy="[{FIELDCODE:'STATUS',FIELDVALUE:'èµ·è',BUTTONS:['listAdd','listDelete','listView',]}]"
    @Input()
    fcViewActionStrategy: string;
    _viewAction: any[];
    @Input()
    fcButtons: Sysappbuttons[];
    @Input()
    fcLayout: string;
    /**æé®æ¯å¦ç¦ç¨*/
    @Input()
    fcDisableds: string;
    /**æ¯å¦æé´é*/
    @Input()
    fcHasGap: string;
    _hasgap: boolean;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-tlblist');
        this.fcButtons = [];
        if (this.fcHasGap === undefined) {
            this._hasgap = false
        }
    }
    _afterParentInit() {
        this._viewAction = [];
        if (this.fcViewActionStrategy) {
            try {
                this._viewAction = JSON.parse(this.fcViewActionStrategy);
            } catch{
                this.logService.error('æé®æ¾ç¤ºç­ç¥å¼å¼å¸¸ï¼è¯·åèï¼[{"FIELDCODE":"STATUS","FIELDVALUE":"èµ·è","BUTTONS":["listAdd","listDelete","listView"]}]æ ¼å¼');
            }
        }

        if (this.fcButtons === undefined || this.fcButtons.length === 0) {
            if (this.fcAppid === undefined && this.fcApp === undefined) {
                throw new Error("ç¼ºå°å·¥å·æ ç»ä»¶");
            }
            if (this.fcViewActionStrategy) {
                // å¤çå¼
                let actions = "";
                let noactions = "";
                this._viewAction.forEach(view => {
                    let value = this.params.data[view.FIELDCODE];
                    if (value === view.FIELDVALUE
                        || (view.FIELDVALUE === 'isnull' && (value === undefined || value === null || value === '')
                            || (view.FIELDVALUE === 'isnotnull' && (value !== null && value !== undefined && value !== '')))) {
                        if (view.BUTTONS) {
                            actions += view.BUTTONS.join(",");
                        }
                    }
                    if (value === view.FIELDNOSHOWVALUE) {
                        view.NOSHOWBUTTONS.forEach(btn => {
                            noactions += btn + ",";
                        })
                    }
                });
                this.fcButtons = this.fcApp.SYSAPPBUTTONS.filter(btn => {
                    // ä¸åè®¸æ¾ç¤ºç­ç¥
                    if (noactions !== "" && noactions.indexOf(btn.ACTCODE) !== -1) {
                        return false;
                    }
                    // ç­ç¥
                    if (actions !== "") {
                        if (actions.indexOf(btn.ACTCODE) === -1) {
                            return false;
                        } else {
                            return btn.BTNTYPE === 'LIST';
                        }
                    } else {
                        return btn.BTNTYPE === 'LIST';
                    }
                });
            } else {
                this.fcButtons = this.fcApp.SYSAPPBUTTONS.filter(btn => btn.BTNTYPE === 'LIST');
            }

        }
        if (this.fcHasGap === 'Y') {
            this._hasgap = true
        }
        if (this.fcLayout === undefined) {
            this.fcLayout = ToolbarListLayout.LEFT;
        }
    }

}

export const ToolbarListLayout = {
    LEFT: "left",
    CENTER: "center",
    RIGHT: "right"
}

export const ToolbarListAction = {
    NEXT: "next  ",
    PREV: "prev",
    LISTADD: "listAdd",
    LISTDETELE: 'listDelete',
    LISTHELP: "listHelp",
    EXPORT: "export",
    IMPORT: "import"
}